import { Dialog, DialogProps } from "@mui/material";
import { useEffect } from "react";
import { setDialogOpen } from "../global-variables/idleFlag";

export const TrackedDialog = (props: DialogProps) => {
  const { open } = props;

  useEffect(() => {
    // whenever `open` changes, update the global
    setDialogOpen(open);
    //console.log("dialog opens");
    // on unmount, make sure we clear it if still open
    return () => {
      if (open) {
        setDialogOpen(false);
        //console.log("dialog closes");
      }
    };
  }, [open]);

  return <Dialog {...props} />;
};
